import ApiIntegrface from './api'

export const FAVORITES_PAGE_SIZE = 20
export const FAVORITES_LIST_PAGE_SIZE = 100

export function createFavoriteAlloy(payload, callback, errhandler) {
  const api = new ApiIntegrface()
  api.post('/api/v1/favorite-alloys', payload, callback, errhandler, null, null, true)
}

export function listFavoriteAlloys(params, callback, errhandler) {
  const api = new ApiIntegrface()
  const query = {
    page: 1,
    page_size: FAVORITES_LIST_PAGE_SIZE,
    ...(params && typeof params === 'object' ? params : {}),
  }
  if (typeof params === 'function') {
    errhandler = callback
    callback = params
    query.page = 1
    query.page_size = FAVORITES_LIST_PAGE_SIZE
  }
  api.get('/api/v1/favorite-alloys', query, callback, errhandler, null, null, true)
}

export function deleteFavoriteAlloy(id, callback, errhandler) {
  const api = new ApiIntegrface()
  api.delete(
    `/api/v1/favorite-alloys/${encodeURIComponent(id)}`,
    null,
    callback,
    errhandler,
    null,
    null,
    true
  )
}

export function normalizeFavoriteList(res) {
  if (Array.isArray(res)) return res
  if (!res || typeof res !== 'object') return []
  if (Array.isArray(res.results)) return res.results
  if (Array.isArray(res.items)) return res.items
  if (Array.isArray(res.data)) return res.data
  return []
}
